import PropTypes from 'prop-types';
import {
  Box,
  Card,
  Typography,
  Stack,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import ModalDialog from 'src/components/Global/ModalDialog';

const StyledPartnerImg = styled("img")({
  top: 0,
  width: "100%",
  height: "100%",
  objectFit: "contain",
  position: "absolute",
  padding: "20px",
});

PartnerCard.propTypes = {
  partner: PropTypes.object,
  isDeleting: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default function PartnerCard({ partner, isDeleting, onDelete, onEdit }) {
  const { name, logo, website } = partner;

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Card sx={{ opacity: isDeleting ? 0.3 : 1 }}>
      <Box sx={{ pt: '100%', position: 'relative', backgroundColor: '#f5f5f5' }}>
        <StyledPartnerImg alt={name} src={logo} />
      </Box>

      <Stack spacing={1} sx={{ p: 2 }}>
        <Typography variant="subtitle1">{name}</Typography>
        {website && (
          <Typography 
            variant="body2" 
            color="primary" 
            component="a" 
            href={website} 
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            Visit Website
          </Typography>
        )}
      </Stack>
      <Box sx={{ pl: 2, mb: 3 }}>
        <Stack direction="row">
          <Button
            size="small"
            color="secondary"
            variant="outlined"
            onClick={isDeleting ? null : onEdit}
          >
            Edit
          </Button>
          <Button
            size="small"
            color="error"
            variant="outlined"
            sx={{ ml: 2 }}
            onClick={isDeleting ? null : handleOpenModal}
          >
            Delete
          </Button>
        </Stack>
      </Box>
      <ModalDialog
        title="Delete Partner?"
        subTitle={`Are you sure do you want to delete this partner?`}
        item={name}
        open={openModal}
        handleClose={handleCloseModal}
        handleClickOk={() => {
          handleCloseModal();
          onDelete();
        }}
      />
    </Card>
  );
}
